import _ from "lodash";
import { store } from "../store";
import {
  setGameStageAction,
  setGameCaseAction,
  setGameStatusAction,
  setGameBlockAction,
  addGameActivityAction,
  clearGameStateAction,
  saveHistoryTakingAction,
  setGamePageAction,
  addChecklistAction,
  deleteCheckListAction,
  updateCheckListAction,
  setPresentationFlagAction,
} from "../actions";

export const setGameStage = (data) => {
  store.dispatch(setGameStageAction(data));
};

export const setGameBlock = (data) => {
  store.dispatch(setGameBlockAction(data));
};

export const setGameCase = (data) => {
  store.dispatch(setGameCaseAction(data));
};

export const setGamePage = (data, onViewStatus) => {
  store.dispatch(setGamePageAction(data, onViewStatus));
};

export const setGameStatus = (status) => {
  store.dispatch(setGameStatusAction(status));
};

export const addGameActivity = (questionType, questionId) => {
  const { gameStates } = store.getState();
  if (!_.find(gameStates.activity, { questionId })) {
    store.dispatch(addGameActivityAction(questionType, questionId));
  }
};

export const saveHistoryTaking = (history) => {
  const { historyTaking } = store.getState().gameStates;

  if (!_.find(historyTaking, history)) {
    store.dispatch(saveHistoryTakingAction(history));
  }
};

export const clearGameState = () => {
  store.dispatch(clearGameStateAction());
};

export const addChecklist = (category, type, item, result) => {
  const id = Date.now().toString();

  store.dispatch(addChecklistAction(category, id, type, item, result));
};

export const deleteCheckList = (category, id) => {
  store.dispatch(deleteCheckListAction(category, id));
};

export const updateCheckList = (category, id, type, item, result) => {
  store.dispatch(updateCheckListAction(category, id, type, item, result));
};

export const setPresentationFlag = (flag) => {
  store.dispatch(setPresentationFlagAction(flag));
};
